module.exports = __webpack_public_path__ + "img/food_loaing.bacb8cca.gif";